"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardProjectType = void 0;
var StandardProjectType;
(function (StandardProjectType) {
    StandardProjectType[StandardProjectType["SELLING_PATENTS"] = 0] = "SELLING_PATENTS";
    StandardProjectType[StandardProjectType["ASTEROID"] = 1] = "ASTEROID";
    StandardProjectType[StandardProjectType["GREENERY"] = 2] = "GREENERY";
    StandardProjectType[StandardProjectType["CITY"] = 3] = "CITY";
    StandardProjectType[StandardProjectType["POWER_PLANT"] = 4] = "POWER_PLANT";
    StandardProjectType[StandardProjectType["AQUIFER"] = 5] = "AQUIFER";
    StandardProjectType[StandardProjectType["AIR_SCRAPPING"] = 6] = "AIR_SCRAPPING";
    StandardProjectType[StandardProjectType["BUILD_COLONY"] = 7] = "BUILD_COLONY";
    StandardProjectType[StandardProjectType["BUFFER_GAS"] = 8] = "BUFFER_GAS";
    StandardProjectType[StandardProjectType["MOON_COLONY"] = 9] = "MOON_COLONY";
    StandardProjectType[StandardProjectType["MOON_MINE"] = 10] = "MOON_MINE";
    StandardProjectType[StandardProjectType["MOON_ROAD"] = 11] = "MOON_ROAD";
})(StandardProjectType = exports.StandardProjectType || (exports.StandardProjectType = {}));
//# sourceMappingURL=StandardProjectType.js.map